const getCommissionLabel = (travelAgency, mode) => {
  const defaultLabel = 'Estimated commission';
  try {
    const commissionLabels = travelAgency && travelAgency.settings
    && travelAgency.settings.commissionLabels;
    if (!commissionLabels || Object.keys(commissionLabels).length === 0) {
      return defaultLabel;
    }
    return commissionLabels[mode] || commissionLabels[''] || defaultLabel;
  } catch (e) {
    return defaultLabel;
  }
};

export default getCommissionLabel;
